import {
  REQUEST_RESOLVED,
  ITEM_REPLACED,
  ITEM_UPDATED,
  ITEM_CREATED,
  ITEM_REMOVED
} from "constants/account/collections";

export function createEntityReducer(entityType) {
  return (state = {}, { type, payload, meta }) => {
    if (meta && meta.type === entityType) {
      switch (type) {
        case ITEM_REPLACED:
        case REQUEST_RESOLVED:
          return payload;
        case ITEM_UPDATED:
          return {
            ...state,
            ...payload
          };
        default:
          return state;
      }
    }

    return state;
  };
}

export function createCollectionReducer(entityType) {
  return (state = {}, { type, payload, meta }) => {
    if (meta && meta.type === entityType) {
      switch (type) {
        case REQUEST_RESOLVED:
          if (meta.partial) {
            return {
              ...state,
              ...payload
            };
          }
          return payload;
        case ITEM_UPDATED:
          return {
            ...state,
            [payload.id]: {
              ...state[payload.id],
              ...payload.delta
            }
          };
        case ITEM_REPLACED:
        case ITEM_CREATED:
          return {
            ...state,
            [payload.id]: payload
          };
        case ITEM_REMOVED: {
          const { [payload.id]: omit, ...rest } = state;
          return rest;
        }

        default:
          return state;
      }
    }

    return state;
  };
}
